import { externalLeadLifeCycleRoutes } from "./ExternalLeadLifeCycle/ExternalLeadLifeCycle.router";


export const externalLeadsRoutes = externalLeadLifeCycleRoutes